/** @jsx jsx */

import { jsx, Container, Box, Label, Textarea, Button, Field } from 'theme-ui'

const Contact = () => (

      <Container>
        <Box as="form" action="https://getform.io/f/3a458abf-3b0f-4aad-96ba-fd2da0b68ab8" method="POST" sx={{
          maxWidth: 768,
          px: 3,
        }}>
          
          <Field label="Name" name="name" defaultValue="" />

            <Field label="Email" name="email" defaultValue="" />

            <Field label="Phone" name="phone" defaultValue="" />

            <Label htmlFor="message">Message</Label>
            <Textarea name="message" id="message" rows={6} mb={3} />
            
            <Button>Submit</Button>

          </Box>
        
      </Container>


)

export default Contact
